// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-members tr {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/team-members/club-team-members/club-team-members.component.scss"],"names":[],"mappings":"AACC;EACC,eAAA;AAAF","sourcesContent":[".team-members{\n\ttr{\n\t\tcursor: pointer;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
